/* tslint:disable */
import {Injectable} from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {ERROR_MESSAGES, WARNING_MESSAGES, SUCCESS_MESSAGES} from './message.constants';


@Injectable({
    providedIn: 'root'
})
export class AlertService {
    //To make this service accessible from other classes -Not components-
    static instance: AlertService;

    constructor() {
        //To make this service accessible from other classes -Not components-
        //To call it from outside: AlertService.instance.show_warning_msg('msg);
        AlertService.instance = this;
    }

    showSuccessMsg(msg, showConfirmButton = true) {
        this.showMessage(
            'Success',
            msg,
            'success',
            false,
            showConfirmButton
        )
    }

    showWarningMsg(msgKey) {
        this.showMessage(
            'Warning',
            WARNING_MESSAGES[msgKey] || msgKey,
            'warning',
            false,
        )
    }

    showErrorMsg(msgKey) {
        this.showMessage(
            'Error',
            ERROR_MESSAGES[msgKey] || msgKey,
            'error',
            false,
        )
    }

    showQuestionMarkMsg(msg) {
        return this.showMessage(
            'Question mark',
            msg,
            'question',
            true,
        )
    }

    showConfirmation(msg: string): Promise<boolean> {
        return Swal.fire({
            title: 'Are you sure?',
            text: msg,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            return result.isConfirmed; // Returns true if 'Yes' is clicked
        });
    }

    showMessage(
        title, message, icon = null,
        showCancelButton = false, showConfirmButton = true) {
        return Swal.fire({
            title: title,
            html: message.replace(/\n/g, '<br>'), // Replace new lines with <br> tags
            text: message,
            icon: icon,
            showCancelButton: showCancelButton,
            showConfirmButton: showConfirmButton,
        })
    }

    showTopSuccessMessage(title, message) {
        Swal.fire({
            position: 'top',
            padding: '4em 0',
            icon: 'success',
            title: title,
            text: message,
            showConfirmButton: false,
        })
    }

    showShareCurrentViewMessageWithCommentField(callBack, hash, message, that) {
        Swal.fire({
            title: 'Success',
            text: message,
            icon: 'success',
            input: 'textarea',
            inputPlaceholder: 'Write a comment to share(Optional)'
        }).then(function (result) {
            if (result) {
                //callBack == submitShareViewComment(input, hash) which is in the header.component.ts
                return callBack(result.value, hash, that);
            }
        })
    }


    showUserMaskMessageWithEmailField(callBack, maskID, message, that) {
        Swal.fire({
            title: 'Success',
            text: message,
            icon: 'success',
            input: 'textarea',
            inputPlaceholder: 'Please share your email for file readiness notification.',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Submit',
            preConfirm: (inputValue) => {
                // Validate the email using a regular expression
                const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailPattern.test(inputValue)) {
                    Swal.showValidationMessage('Invalid email format.');
                } else {
                    return inputValue;
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                // result.value contains the valid email address
                callBack(result.value, maskID, that);
            }
        });
    }

    htmlContentFeaturesNotifications(tasks, featuresToNotify, type) {
        let ulClass = type === 'atlas' ? 'features-list atlas' : 'features-list guide';
        let htmlContent = `
<!--                <div id="fish-celebrating-swal-container">-->
<!--                  <img src="assets/imgs/fish_celebrating.gif"  id="fish-celebrating-swal-image">-->
<!--                </div>-->
                <ul class="${ulClass}">
              `;
        for (let i = 0; i < tasks.length; i++) {
            let task = tasks[i];
            let message = featuresToNotify[task]['message'];
            if (featuresToNotify[task]['link'] !== "") {
                let link = featuresToNotify[task]['link']
                // Use a regular expression with the /i flag for case-insensitive search, so the replace will work for "Youtub","youtub",YOUTUB".etc
                let regex = /Youtube/gi;
                // Replace occurrences of "Youtube world" with a clickable link
                message = message.replace(regex, `<a class="blue" target="_blank" href="${link}"> Youtube</a>`);
            }
            htmlContent += `
              <li class="mb-10">
                <label>${message}</label>
              </li>`;
        }
        htmlContent += `</ul>`;
        return htmlContent;
    }

    showNewFeaturesNotifications(tasks, featuresToNotify, type) {
        Swal.fire({
            title: 'New features',
            html: this.htmlContentFeaturesNotifications(tasks, featuresToNotify, type),
            width: 400,
            padding: '3em',
            showConfirmButton: false,
            showCloseButton: true,
            // onOpen: () => {
            //     document.body.appendChild(document.getElementById('fish-celebrating-swal-container'));
            // },
            // onClose: () => {
            //     const customSwalContainer = document.getElementById('fish-celebrating-swal-container');
            //     if (customSwalContainer) {
            //         customSwalContainer.remove();
            //     }
            // },
            backdrop: `
               rgba(16, 83, 98, 0.4)
            `
        });
    }


}

